import React from 'react';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import { Paper } from '@mui/material';
import clsx from 'clsx';

type InlineMessageBoxProps = {
  fullWidth?: boolean;
  noMargin?: boolean;
  showIcon?: boolean;
  text: string;
};

const COMPONENT_CLASSNAME = 'inline-message-box';

const InlineMessageBox = ({ fullWidth, noMargin, showIcon, text }: InlineMessageBoxProps) => (
  <div
    className={clsx(
      COMPONENT_CLASSNAME,
      fullWidth && `${COMPONENT_CLASSNAME}--full-with`,
      noMargin && `${COMPONENT_CLASSNAME}--no-margin`
    )}>
    <Paper elevation={0} className={`${COMPONENT_CLASSNAME}__container`}>
      {showIcon && (
        <ErrorOutlineIcon className={`${COMPONENT_CLASSNAME}__icon`} data-testid={`${COMPONENT_CLASSNAME}__icon`} />
      )}

      <p className={`${COMPONENT_CLASSNAME}__text`}>{text}</p>
    </Paper>
  </div>
);

export default InlineMessageBox;
